import { Component } from '@angular/core';
import { Appointment, Step, Substep } from './appointment';
import { FormsModule } from '@angular/forms';

import { Pool, Swimlane } from './pool';
import { Pill } from './pill';
import { Site } from '../site';
import { QueueService } from './queue.service';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { provideNativeDateAdapter } from '@angular/material/core';
import { CdkDragDrop, CdkDragEnd, DragDropModule, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { SwimlaneAppointments } from './swimlane-appointments';

@Component({
    selector: 'app-queue',
    imports: [
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    DragDropModule
],
    providers: provideNativeDateAdapter(),
    templateUrl: './queue.component.html',
    styleUrl: './queue.component.scss'
})
export class QueueComponent {
  sites: Site[] = []
  selectedSite: number = 0
  selectedDate: Date | null = null
  selectedAppointment: Appointment | null = null
  selectedAppointmentOrdinal = 0
  stepOrdinal = 0
  pools: {[key: number]: Pool} = {}
  previousAppointmentIds: number[] = []
  selectedAppointmentStepsForPills: Pill[] = []
  selectedAppointmentOnLastStep=false
  clientSearchString = ""
  appointmentPool: {[key: number]: SwimlaneAppointments[]} = {}

  constructor(private queueService: QueueService) { }

  ngOnInit() {
    this.queueService.getSites().subscribe(response => {
      this.sites = response
    })

    this.queueService.getPossibleSwimlanes().subscribe(response => {
      this.pools = response
      this.getPossibleSubsteps();
      this.createAppointmentPool()
    })
  }

  getPossibleSubsteps() {
    this.queueService.getPossibleSubsteps().subscribe((response) => {
      if (response == null || !response.success) {
        // const errorMessage = response ? response.error : 'There was an error on the server accessing appointment subcategories. Please refresh the page and try again.';
        // NotificationUtilities.giveNotice('Failure', errorMessage, false);
      } else {
        const possibleSubsteps = response.possibleSubsteps;

        for (const key in this.pools) {
          const pool = this.pools[key]
          pool.swimLanes.forEach(swimlane => {
            swimlane.possibleSubsteps = []
          })
        }
        possibleSubsteps.forEach((substep: Substep) => {
          const swimlane = this.pools[substep.progressionTypeId].swimLanes[substep.progressionStepOrdinal]
          swimlane.possibleSubsteps.push(substep);
        });
      }
    });	
  }

  createAppointmentPool() {
    this.appointmentPool = {}
    for (const key in this.pools) {
      const pool = this.pools[key]

      let swimlanes: SwimlaneAppointments[] = []
      for (const swimlane of pool.swimLanes) {
        swimlanes.push({
          stepId: swimlane.stepId,
          stepOrdinal: swimlane.stepOrdinal,
          stepName: swimlane.stepName,
          appointments: [],
          possibleSubsteps: [],
        })
      }
      this.appointmentPool[pool.progressionTypeId] = swimlanes
    }
  }

  dateChanged(newObj: Date) {
    this.getProgressionSteps()
  }

  deselectAppointment() { 
    this.selectedAppointment = null;
    this.selectedAppointmentOrdinal = 0;
    this.selectedAppointmentOnLastStep = false;
    this.selectedAppointmentStepsForPills = [];
  }

  markAppointmentAsIncomplete(appointmentId: number) { 
    this.queueService.markAppointmentAsIncomplete(appointmentId)
    .subscribe( result => {
      if (!result) return;
      console.log("Incomplete")
    })
  }

  markAppointmentAsCancelled(appointmentId: number) { 
    this.queueService.markAppointmentAsCancelled(appointmentId)
    .subscribe( result => {
      if (!result) return;

      this.parseAppointments('removeAppointmentFromSwimlanes', appointmentId);
      console.log("Cancelled!")
    })
  }

  resetSwimlanes() {
    this.parseAppointments('resetSwimlanes', 0)
    this.previousAppointmentIds = [];
  }

  siteChanged(){ 
    this.resetSwimlanes()
    this.getProgressionSteps()
  }

  selectSubstep(stepOrdinal: number) {
    if (this.selectedAppointment != null) {
      const appointmentId = this.selectedAppointment.appointmentId;
      // The appt won't have a full step object here
      // store it in the ordinal of the step the dropdown belongs to, not the current ordinal of the appt.
      const substepId = this.selectedAppointment.steps[stepOrdinal]['substepId'];
      // get the substep name through the temporary pills object // TODO is there a way to pass key/val straight to here?
      const substepName = this.selectedAppointmentStepsForPills[stepOrdinal]['possibleSubsteps'][substepId];
      this.selectedAppointment.steps[stepOrdinal].substepName = substepName.name;

      this.queueService.insertSubstepTimestamp(appointmentId, substepId)
      .subscribe(response => {
        if (!response) {
          // const errorMessage = response ? response.error : "There was an error on the server updating the appointment's sub-category. Please refresh the page and try again.";
          // NotificationUtilities.giveNotice('Failure', errorMessage, false); //todo i belive this will pop up and say "undefined" if the session ends. that should be falsy, look into it.
        }  
      })
    }
   }

  selectAppointment(appointment: Appointment, progressionTypeId: number, currentStepOrdinal: number, appointmentOnLastStep: boolean) {
    this.selectedAppointment = appointment;
    console.log("selectAppointment()111", this.selectedAppointment)
    this.selectedAppointmentStepsForPills = this.getAppointmentPills(currentStepOrdinal, progressionTypeId);
    // this.appointmentNotesAreaSharedProperties.appointmentId = this.selectedAppointment.appointmentId;
    this.selectedAppointmentOrdinal = Number(currentStepOrdinal);
    this.selectedAppointmentOnLastStep = appointmentOnLastStep;
   }
  getAppointmentPills(currentStepOrdinal: number, progressionTypeId: number): Pill[] {
    // want to return [{stepName, done or not}]
    const stepsForPills: Pill[] = []
    const pool = this.pools[progressionTypeId]
    for (const swimlane of pool.swimLanes) {
      stepsForPills.push( // "key" is ordinal, this is more future-proof.
        {
          stepName: swimlane.stepName,
          stepCompleted: swimlane.stepOrdinal <= currentStepOrdinal,
          possibleSubsteps: swimlane.possibleSubsteps,
          stepOrdinal: swimlane.stepOrdinal,
        })
    }

    return stepsForPills;
  }


  parseAppointments(action: string, id: number): boolean {
    for (const key in this.pools) {
      const pool = this.pools[key]
      for (const swimlane of pool.swimLanes) {
        switch(action) {
          case 'resetSwimlanes':
              swimlane.appointments = {};
            break;
          case 'removeAppointmentFromSwimlanes':
            if (swimlane.hasOwnProperty(id)) {
              delete swimlane.appointments[id]; // todo need to test!! this is why we shouldn't use array and should use object with apptID as key.
            }
            break;
          case 'markAppointmentAsCompleted':
            if (swimlane.hasOwnProperty(id)) {
              swimlane.appointments[id].ended = true; // todo do i need to init the appt object with this? or if it's undefined/null it's assumed not to have ended
            }
            break;
          case 'markAppointmentAsBeingPrepared':
            if (swimlane.hasOwnProperty(id)) {
              swimlane.appointments[id].preparing = true;
              swimlane.appointments[id].ended = false;
            }
            break;
          case 'areThereAnyAppointments':
            if (!(Object.keys(swimlane.appointments).length === 0)) {
              return true;
            }
            break;
          case 'doSomePassSearchFilter':
            for (const [appointmentId, appointment] of Object.entries(swimlane.appointments)) {	
              if (this.passesSearchFilter(appointment)) {
                  return true;
              }
            }
            break;
          default:
            // todo error handle here
            console.log("something went wrong");
        }
      }
    }
    if(action === 'areThereAnyAppointments' || action === 'doSomePassSearchFilter') {
      return false;
    }  

    return true;
  }

  hasAppointments(pool: Pool): boolean {
    const hasAppointments = pool.swimLanes.some(schedule => Object.keys(schedule.appointments??{}).length > 0);

    return hasAppointments;
 }

  getAppointmentsFromSwimlane(swimlane: Swimlane): Appointment[] {
    let appointments: Appointment[] = []
    for (const [key, appointment] of Object.entries(swimlane.appointments??{})) {
      appointments.push(appointment)
    }

    return appointments
  }

  getPoolList(): Pool[] {
    let pools: Pool[] = []
    for (const key in this.pools) {
      pools.push(this.pools[key])
    }

    return pools
  }

  passesSearchFilter(appointment: Appointment): boolean {
    const searchString = this.clientSearchString.toLowerCase();
    if (!searchString) return true;
    return appointment.clientName.toLowerCase().indexOf(searchString) !== -1 ||
      appointment.appointmentId.toString().indexOf(searchString) !== -1;
}

  getProgressionSteps() {
    if (!this.selectedDate) { return }

    const year = this.selectedDate.getFullYear()
    const month = (this.selectedDate.getMonth() + 1 + "").padStart(2,'0')
    const day = (this.selectedDate.getDate() + "").padStart(2,'0')
    const key = `${year}-${month}-${day}`

    this.queueService.getProgressionSteps(key, this.selectedSite)
    .subscribe(result => {
      this.createAppointmentPool()
      const appointments: { [key: number]: Appointment} = {}
      const progressionSteps = result
      progressionSteps.forEach((step) => {
        let appointmentId: number = 0
        if (appointmentId = step.appointmentId as number) {
          if (!(appointmentId in appointments)) {
            const steps: {[key: number]: Step} = {}
            steps[step.progressionStepOrdinal] =  {
              stepOrdinal: step.progressionStepOrdinal,
              stepName: step.progressionStepName ?? '',
              stepTimeStamp: step.timestamp ?? '',
              substepId: step.progressionSubStepId ?? 0,
              substepName: step.progressionSubstepName ?? ''
            }
            appointments[appointmentId] = {
              appointmentId: appointmentId,
              appointmentType: step.appointmentType,
              answersByLookup: step.answersByLookup,
              scheduledTime: step.scheduledTime,
              clientName: step.clientName,
              noShow: step.noShow ?? false,
              ended: step.ended ?? false,
              preparing: step.preparing ?? false,
              name: step.firstName + ' ' + step. lastName,
              steps: steps,
              cancelled: step.cancelled,
              language: step.language ?? '',
              walkIn: step.walkIn,
              visa: step.visa ?? '',
              phoneNumber: step.phoneNumber,
              emailAddress: step.emailAddress,
              progressionStepName: step.progressionStepName,
            }
          } 
          else {
            // if the appointment object is already made, we only need to add to its list of steps
            // (first might be checked-in, then here we add the timestamp for the "paperwork complete" step)
            appointments[appointmentId]['steps'][step.progressionStepOrdinal] =
              {
                stepOrdinal: step.progressionStepOrdinal,
                stepName: step.progressionStepName ?? '',
                stepTimeStamp: step.timestamp ?? '',
                substepId: step.progressionSubStepId ?? 0,
                substepName: step.progressionSubstepName ?? ''
              };
          }
          // we sort in sql so that the most recent step (advancement_rank = 1) comes last.
          // So if advancement_rank = 1, we are on the last database entry for this appointment,
          // and we can proceed to use this appointment's object now that it's complete.
          // if(step.advancement_rank == 1) { // TODO could move this check above and skip the step (break out of the loop) completely if it's already included.
            // Only add appointments if 1) they don't exist in any swimlane, or 2) they've been moved/removed already (by another volunteer)
            // I've ignored case 2 however, as I don't think it'll happen all too often, so it's not worth the extra logic
            // TODO could store previousAppointmentIds with their previous Ordinal step and see if it changed here.
            const exists = this.previousAppointmentIds.some((apptId) => apptId === appointmentId);
            if (!exists) {
              this.previousAppointmentIds.push(appointmentId);
              // if we are adding it, last thing to add to the appt object is no-show status
              // Appt is no-show if they are 30 minutes late and they haven't started their appt
              // Since we are on the most recent step for this appointment (see comment above),
              // if this step is the first with a null timestamp, they haven't started their appt
              var noShow = false; // default to false;
              var ordinal = null;
              if (step.timestamp === null) {
                const noShowDeadline = new Date(new Date(step.scheduledDatetime).getTime() + 30*60000); // 30 minutes to show up
                noShow = noShowDeadline < new Date();
                // (unrelated to noShow) if timestamp if null, then this is the default beginning
                // progressionStep made in storeAppointment.php, insertNullProgressionStepTimestamp().
                ordinal = 0;
              } else {
                ordinal = step.progressionStepOrdinal
              }

              appointments[appointmentId].noShow = noShow;
              // ex: in the pool or progression type 'Virtual', in the second ordinal swimlane,
              // we are going to add this appointment object with the appt id as the key.

              let progressionStepId = step.progressionTypeId ?? 0;
              if (this.pools[progressionStepId] === undefined) {
                this.pools[progressionStepId] = {
                  progressionTypeId: progressionStepId,
                  progressionTypeName: 'Progression',
                  ProgressionTypeMaxOrdinal: 4,
                  swimLanes: [],
                };
                this.pools[progressionStepId].swimLanes[ordinal] = {
                  stepId: progressionStepId,
                  stepOrdinal: ordinal,
                  stepName: "not found",
                  appointments: {},
                  possibleSubsteps: [],
                }
              }
              if (this.pools[progressionStepId].swimLanes[ordinal].appointments === undefined) {
                this.pools[progressionStepId].swimLanes[ordinal].appointments = {}
              }

              this.pools[progressionStepId].swimLanes[ordinal].appointments[appointmentId] = appointments[appointmentId];
              this.appointmentPool[progressionStepId][ordinal].appointments.push(appointments[appointmentId])
            }
          }
        // }
      })

    })

  }

  getAppointmentSubstepName(appointment: Appointment): string {
    return appointment.steps[this.stepOrdinal]?.substepName ?? ''
  }

  //MARK: Dragable
  drop(event: CdkDragDrop< Appointment[]>, pool: Pool) {
    transferArrayItem(
      event.previousContainer.data,
      event.container.data,
      event.previousIndex,
      event.currentIndex,
    )

    const currentSwimlane = event.previousContainer.element.nativeElement.id
    const nextSwimlane = event.container.element.nativeElement.id
    const currentSwimLaneStepId = Number(currentSwimlane.split('_')[5])
    const nextSwimLaneStepId = Number(nextSwimlane.split('_')[5])
    const appointment = event.container.data[event.currentIndex]

    this.queueService.insertStepTimestamp(appointment.appointmentId, nextSwimLaneStepId=== 0? currentSwimLaneStepId: nextSwimLaneStepId, nextSwimLaneStepId === 0, currentSwimLaneStepId === 0)
          .subscribe(result => {
            if (!result) return;
            let currentSwimlane = pool.swimLanes.find((value: Swimlane, index: number, obj: Swimlane[]) => value.stepId === currentSwimLaneStepId);
            let nextSwimlane = pool.swimLanes.find((value: Swimlane, index: number, obj: Swimlane[]) => value.stepId === nextSwimLaneStepId);
            if (pool.ProgressionTypeMaxOrdinal === nextSwimlane?.stepOrdinal) {
              this.queueService.markAppointmentAsCompleted(appointment.appointmentId)
              .subscribe( compoletedResult => {
                if (!compoletedResult) return;
                // Completed! WOOOO!
                this.parseAppointments('markAppointmentAsCompleted', appointment.appointmentId)
              })
            }
            if (pool.ProgressionTypeMaxOrdinal === currentSwimlane?.stepOrdinal && currentSwimlane?.stepOrdinal != nextSwimlane?.stepOrdinal) {
              this.markAppointmentAsIncomplete(appointment.appointmentId)
            }
          })
    // this.queueService.deleteTimestamp(appointment.appointmentId, currentSwimLaneStepId)
    // .subscribe(result => {
    //   if (result)
        
    // })
  }
}


